
import {
  computed,
  defineComponent,
  onMounted,
  onUnmounted,
  PropType,
  ref,
  watch,
} from "vue"

import { OcrResult } from "@/api/ocr/type"

export default defineComponent({
  name: "ImgView",
  props: {
    activeIndex: {
      type: Number,
      default: 0,
    },
    imgList: {
      type: Array as PropType<OcrResult.Res>,
      default: () => [],
    },
  },
  setup(props, { emit }) {
    // 禁止样式
    const notAllowedStyle = {
      cursor: "not-allowed",
      color: "#D8D8D8",
      backgroundColor: "#F6F6F6",
      border: "1px #D8D8D8 solid",
    }
    const scaleValue = ref(100)
    const activeUrl = ref("")
    const contentRef = ref()
    const initImgRef = ref()
    const showImgRef = ref()
    const show = ref(false)
    const initStyle = {
      rotate: 0, // 旋转角度
      initScale: 1, // 初始缩放比例
      scale: 1, // 缩放比例
      top: 0,
      left: 0,
    }
    let moveStartX: number,
      moveStartY: number,
      moveStartTop: number,
      moveStartLeft: number
    const imgBoxStyle = ref({
      ...initStyle,
    })
    // 图片样式
    const showImgStyle = computed(() => {
      return {
        transform: `scale(${imgBoxStyle.value.scale}) rotate(${imgBoxStyle.value.rotate}deg)`,
        top: `${imgBoxStyle.value.top}px`,
        left: `${imgBoxStyle.value.left}px`,
      }
    })
    let showImgDom: any
    watch(
      () => props.activeIndex,
      (newValue) => {
        activeUrl.value = props.imgList[newValue].image
        show.value = false
        imgBoxStyle.value = { ...initStyle }
        scaleValue.value = 100
      },
      {
        immediate: true,
      }
    )
    const formatScaleTip = (value: number)  => `${value}%`
    // 移动图片
    function handlerMove(e: MouseEvent) {
      e.preventDefault()
      imgBoxStyle.value.top = e.clientY - moveStartY + moveStartTop
      imgBoxStyle.value.left = e.clientX - moveStartX + moveStartLeft
    }
    function handleScaleStep(flag: string) {
      const scaleStep = [100, 110, 125, 150, 175, 200, 250, 300]
      let val = 100
      if (flag === 'narrow') {
        val = scaleStep.reverse().find(item => scaleValue.value > item) ?? 100
      } else {
        val = scaleStep.find(item => scaleValue.value < item) ?? 300
      }
      changeScale(val)
    }
    // 缩放图片
    function changeScale(val: number) {
      const initScale = imgBoxStyle.value.initScale
      if (val > 300) return
      scaleValue.value = val
      imgBoxStyle.value.scale = initScale + (val - 100) / 100
    }
    // 切换图片
    function toggleImg(flag: string) {
      if (flag === "pre") {
        // 上一张
        let pre = props.activeIndex - 1
        if (pre <= 0) {
          pre = 0
        }
        emit('update:activeIndex', pre)
      } else if (flag === 'next') {
        // 下一张
        let next = props.activeIndex + 1
        if (next >= props.imgList.length - 1) {
          next = props.imgList.length - 1
        }
        emit('update:activeIndex', next)
      }
    }
    onMounted(() => {
      showImgDom = showImgRef.value
      // 监听鼠标事件来拖动图片(图片相对定位relative,改变top和left的值)
      showImgDom.addEventListener('mousedown', (e: MouseEvent) => {
        e.preventDefault()
        moveStartX = e.clientX
        moveStartY = e.clientY
        moveStartTop = imgBoxStyle.value.top
        moveStartLeft = imgBoxStyle.value.left
        showImgDom.addEventListener("mousemove", handlerMove)
      })
      document.addEventListener("mouseup", () => {
        showImgDom.removeEventListener("mousemove", handlerMove)
      })
      // 通过鼠标滚轮缩放图片
      showImgDom.addEventListener("mousewheel", handleMouseWheel)
      window.addEventListener('resize', loadImg)
    })

    onUnmounted(() => {
      showImgRef.value?.removeEventListener("mousewheel", handleMouseWheel)
      showImgRef.value?.removeEventListener("mouseup", handlerMove)
      showImgRef.value?.removeEventListener("mousemove", handlerMove)
    })

    // 滚轮缩放图片
    function handleMouseWheel(e: any) {
      e.preventDefault()
      e.returnValue = false
      e.stopPropagation()
      e.cancelBubble = true
      const wheelDelta = e.wheelDelta
      if (wheelDelta > 0) {
        scaleValue.value += 10
      } else {
        scaleValue.value -= 10
      }
      changeScale(scaleValue.value)
    }
    // 加载图片
    function loadImg() {     
      const boxWidth = contentRef.value.clientWidth
      const boxHeight = contentRef.value.clientHeight 
      show.value = true // 图片加载完成后在显示
      const initWidth = initImgRef.value.naturalWidth
      const initHeight = initImgRef.value.naturalHeight
      // 两遍留些缝隙 宽高减小8px
      const radioWidth = (boxWidth - 8) / initWidth
      const radioHeight = (boxHeight - 8) / initHeight
      const radio = Math.min(radioWidth, radioHeight)
      imgBoxStyle.value.scale = radio
      imgBoxStyle.value.initScale = radio
      changeScale(scaleValue.value)
    }
    
    onUnmounted(() => {
      window.removeEventListener('resize', loadImg)
    })
    return {
      notAllowedStyle,
      scaleValue,
      activeUrl,
      contentRef,
      initImgRef,
      showImgRef,
      show,
      loadImg,
      showImgStyle,
      changeScale,
      toggleImg,
      handleScaleStep,
      formatScaleTip
    }
  }
})
